module.exports = __webpack_public_path__ + "img/custom-03.786dfe01.jpg";